export default __webpack_public_path__ + "static/media/grandma.94c94a9f.svg";